import { Portfolio } from '../../types/entities';

export interface PortfolioState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  portfolios: Portfolio[];
}

export const initialPortfolioState: PortfolioState = {
  loading: false,
  loaded: false,
  error: undefined,
  portfolios: []
};
